import { Link } from 'react-router-dom';
import { shows, featuredShows } from '@/mocks/shows';
import { sortShows } from '@/utils/shows';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import LatestList from '@/pages/home/components/LatestList';
import RankList from '@/pages/home/components/RankList';
import ShowCard from '@/components/feature/ShowCard';
import SectionHeading from '@/components/feature/SectionHeading';

export default function Home() {
  const latest = sortShows(shows, 'updated').slice(0, 10);
  const topRanked = sortShows(shows, 'score').slice(0, 8);
  const hotPicks = sortShows(shows, 'score').slice(0, 20);

  return (
    <div className="w-full">
      <HeroCarousel shows={featuredShows} />

      <CategoryGrid />

      <section className="px-4 md:px-6 pb-10 md:pb-14">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <SectionHeading
              title="最新更新"
              subtitle="最新同步与上架的高评分剧集"
              icon="ri-time-line"
              moreTo="/category/guochan"
              moreLabel="更多分类"
            />
            <LatestList shows={latest} />
          </div>

          <aside className="lg:col-span-1">
            <div className="bg-background-100 border border-background-200 rounded-lg p-4 md:p-5 lg:sticky lg:top-20">
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-100 text-accent-600">
                  <i className="ri-trophy-line text-lg"></i>
                </span>
                <h2 className="font-heading font-bold text-base md:text-lg text-foreground-950">高分榜</h2>
              </div>
              <RankList shows={topRanked} />
            </div>
          </aside>
        </div>
      </section>

      <section className="px-4 md:px-6 pb-10 md:pb-14">
        <SectionHeading
          title="本月热门高分推荐"
          subtitle="精选 20 部口碑与评分俱佳的剧集"
          icon="ri-fire-line"
          moreTo="/search"
          moreLabel="浏览更多"
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
          {hotPicks.map((show) => (
            <ShowCard key={show.id} show={show} />
          ))}
        </div>
      </section>

      <section className="px-4 md:px-6 pb-14 md:pb-20">
        <div className="relative overflow-hidden rounded-lg bg-primary-900 px-6 py-10 md:px-12 md:py-14">
          <div className="absolute -right-10 -top-10 w-52 h-52 rounded-full bg-accent-500/20"></div>
          <div className="absolute -left-16 -bottom-16 w-64 h-64 rounded-full bg-primary-700/40"></div>
          <div className="relative max-w-3xl">
            <span className="text-xs font-medium px-3 py-1 rounded-full bg-accent-500 text-background-50">
              关于本站
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mt-4">
              专注为你筛选真正值得看的高分电视剧
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-background-100/90">
              高评分电视剧网站汇集最新热门、高评价的电视剧资源，覆盖国产剧、海外剧、古装剧、悬疑剧等多类别。
              我们以评分、口碑与内容质量为核心标准，帮助你快速找到优质影视内容，省去在海量剧集中反复挑选的时间。
            </p>
            <div className="flex items-center gap-3 mt-7 flex-wrap">
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                了解我们
              </Link>
              <Link
                to="/category/xuanyi"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-50/15 text-background-50 text-sm font-semibold hover:bg-background-50/25 transition-colors cursor-pointer whitespace-nowrap"
              >
                看看悬疑剧
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}